import React, { useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { EmailTextBox } from '../TextBox/EmailTextBox'
import { PasswordTextBox } from '../TextBox/PasswordTextBox'
import { AuthHelper } from '../../helpers/AuthHelper'
import { Form } from './Form'
import { Button, ButtonThemeType } from '../Button'
import { LocaleHelper } from '../../helpers/LocaleHelper'
import { showAlert } from '../../states/alerts/actions'
import { ButtonType } from '../Button/ButtonType.constants'
import { showModal } from '../../states/modals/actions'
import { ModalType } from '../../states/modals/ModalType.constants'
import { Link } from '../Link'

type SignUpField = { email: string; password: string }

type SignUpFormProps = {
  isAuthByCognito?: boolean
  isAuthByFacebook?: boolean
  isAuthByGoogle?: boolean
  onSuccess?: (formFields: SignUpField) => void
}

const StyledButton = styled(Button)`
  margin-top: 1rem;
`

const LoginLink = styled(Link)`
  display: block;
  width: 100%;
  margin-top: 1rem;
`

const SignUpForm = ({
  isAuthByCognito,
  isAuthByFacebook,
  isAuthByGoogle,
  onSuccess,
}: SignUpFormProps) => {
  const dispatch = useDispatch()
  const [formFields, setFormFields] = useState<SignUpField>({
    email: '',
    password: '',
  })
  return (
    <Form
      formFields={formFields}
      onChange={(ff) => setFormFields(ff as SignUpField)}
      onSubmit={() => {
        AuthHelper.signUp({
          username: formFields.email,
          password: formFields.password,
        })
          .then(() => {
            if (onSuccess) {
              onSuccess(formFields)
            }
          })
          .catch((ex) => {
            const { code } = ex
            dispatch(showAlert(LocaleHelper.getText(code)))
          })
      }}
    >
      <EmailTextBox
        labelText="Email"
        name="email"
        validation="email"
        required
      />
      <PasswordTextBox
        labelText="Password"
        name="password"
        validation="password"
        required
      />
      <PasswordTextBox
        labelText="Confirm password"
        name="confirmPassword"
        validation="confirmPassword"
        required
      />
      <StyledButton
        label="Sign up"
        theme={ButtonThemeType.PRIMARY}
        type={ButtonType.SUBMIT}
      >
        Sign up
      </StyledButton>
      <LoginLink
        onClick={() =>
          dispatch(
            showModal(ModalType.LOGIN, {
              props: {
                isAuthByCognito,
                isAuthByFacebook,
                isAuthByGoogle,
                hasSignUp: true,
              },
            })
          )
        }
      >
        Login
      </LoginLink>
    </Form>
  )
}

export { SignUpForm }
